import React, { FC } from 'react';
import { Game } from '../../../../components/Games/games.model';

interface GameTileProps {
  game: Game;
  className: string;
  onClick: (game: Game) => void;
}

export const GameTile: FC<GameTileProps> = ({ game, className, onClick }) => {
  const imageUrl = game.gameImageBox.imgUrl || game.gameImage.imgUrl;

  return (
    <div
      className={className}
      style={{ backgroundImage: `url(${imageUrl})` }}
      onClick={(): void => onClick(game)}
      title={game.displayName}
    />
  );
};
